import { toast } from 'sonner';

export const sonnerSuccessAlert = (message) => {
  toast.success(message);
};

export const sonnerErrorAlert = (message) => {
  toast.error(message);
};

export const sonnerInfoAlert = (message) => {
  toast.info(message);
};

export const sonnerWarningAlert = (message) => {
  toast.warning(message);
};
